/* ============================================================
   ORION REVIEWS — progressive "show more" for the review wall.

   Every card is server-rendered so the full text is in the HTML for
   crawlers and for anyone without JS. This script is what *hides* the
   tail and adds the button, which is the right way round: a no-JS
   visitor sees all the reviews rather than a dead button and six.
   ============================================================ */
(() => {
  const STEP_ATTR = 'data-orion-review-step';

  function clampCards(root) {
    /* phones clamp long quotes to four lines; a View more button appears
       only on cards where the clamp actually hides something */
    if (window.matchMedia('(min-width: 750px)').matches) return;
    root.querySelectorAll('.o-rev__card').forEach((card) => {
      const q = card.querySelector('.o-rev__quote');
      if (!q || card.querySelector('.o-rev__expand')) return;
      q.classList.add('is-clampable');
      if (q.scrollHeight > q.clientHeight + 2) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'o-rev__expand';
        b.textContent = 'View more';
        b.setAttribute('aria-expanded', 'false');
        b.addEventListener('click', () => {
          const open = card.classList.toggle('is-open');
          b.textContent = open ? 'View less' : 'View more';
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        q.after(b);
      } else {
        q.classList.remove('is-clampable');
      }
    });
  }

  function setup(root) {
    const grid = root.querySelector('[data-orion-review-grid]');
    const slot = root.querySelector('[data-orion-review-more]');
    clampCards(root);
    if (!grid || !slot || slot.dataset.ready === '1') return;

    const cards = Array.from(grid.children);
    const base = parseInt(root.getAttribute('data-orion-review-initial'), 10) || 6;
    /* the initial reveal fills the column ladder exactly: two rows of four
       on wide screens, two of three in the middle, three cards on phones.
       Anything less leaves a column empty and the wall looks broken. */
    const initial = window.matchMedia('(min-width: 1200px)').matches
      ? Math.max(base, 8)
      : window.matchMedia('(max-width: 749px)').matches
        ? Math.min(base, 4)
        : base;
    const step = parseInt(root.getAttribute(STEP_ATTR), 10) || initial;
    if (cards.length <= initial) return;

    slot.dataset.ready = '1';
    let shown = initial;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'o-btn o-btn--ghost o-rev__more';

    const paint = () => {
      cards.forEach((card, i) => {
        card.hidden = i >= shown;
      });
      const left = cards.length - shown;
      if (left <= 0) {
        button.remove();
        return;
      }
      button.textContent = (slot.dataset.label || 'Show more reviews') + ' (' + left + ')';
    };

    button.addEventListener('click', () => {
      setTimeout(() => clampCards(root), 50);
      const firstNew = cards[shown];
      shown = Math.min(shown + step, cards.length);
      paint();
      // Land focus on the first newly revealed card so keyboard and screen
      // reader users aren't dumped back at the top of the wall.
      if (firstNew) {
        firstNew.setAttribute('tabindex', '-1');
        firstNew.focus({ preventScroll: true });
      }
    });

    slot.appendChild(button);
    paint();
  }

  const boot = () => document.querySelectorAll('[data-orion-reviews]').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // The theme editor re-renders a section in place rather than reloading.
  document.addEventListener('shopify:section:load', boot);
})();
